import { gsap } from 'gsap';
import { ScrollTrigger } from '../../../node_modules/gsap/dist/ScrollTrigger.js';
import { MotionPathPlugin } from '../../../node_modules/gsap/dist/MotionPathPlugin.js';


class SolarSystem {
	selectors = {
		trigger: '.solar-system__wrap',
		path: '.solar-system__path',
		planet: '.solar-system__planet',
		group: '.solar-system__group'
	};
	opts = {
		planetMaxWidth: 20,
	}

	constructor( node ) {
		this.node = node;
		gsap.registerPlugin(
			ScrollTrigger,
		);
		this.mm = gsap.matchMedia();
		this.init();
	}

	init() {
		const { group, trigger } = this.selectors;

		this.groups = this.node.querySelectorAll(group);

		this.tl = gsap.timeline({
			// onUpdate: () => {},
			defaults: {
				ease: "none",
			},
		});

		this.scrollTrigger = {
			trigger: this.node.querySelector(trigger),
			pin: false,
			scrub: true,
			start: "top bottom",
			end: "bottom top"
		};

		this.animate();
	}

	animate() {


		[...this.groups].forEach((element, index) => {

			const rotation = Math.floor(Math.random() * 720);

			this.tl.to( element, {
				rotation,
				transformOrigin: "50% 50%",
				scrollTrigger: this.scrollTrigger
			} );
		});
		// this.tl.to(this.groups, {rotation:360, transformOrigin:"50% 50%"}, "+=1");

	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.solar-system' ).forEach(system => {
		new SolarSystem( system );
	})
});

export default SolarSystem;
